var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./broker.constants";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, isFetchingCount = _a.isFetchingCount, isFetchingAllWhere = _a.isFetchingAllWhere, isFetchingDetail = _a.isFetchingDetail, fetchDetailError = _a.fetchDetailError;
